import React from 'react'

const Child = () => {
  return (
    <div>
      child
    </div>
  )
}

export default Child
